<apt-template-nested-state state="info" title="ACCESS DENIED">
  <ng-container message>
    <p>{{ 'LandingComponent.accessDenied' | translate }}</p>
  </ng-container>
</apt-template-nested-state>
